export function convertDecimalToHour(decimalValue: number): string {
  const hours = Math.floor(decimalValue);
  const minutes = Math.round((decimalValue - hours) * 60);
  return `${hours}:${minutes.toString().padStart(2, "0")}`;
}
